import { Injectable } from '@angular/core';
import { OnlineInterfaceService } from '../online-interface-service/online-interface.service';
import { StorageService } from '../storege-service/storage.service';
import { HttpJavaService } from '../http-java-service/http-java.service';
import { GlobalSettingsService } from '../global-settings-service/global-settings.service';
import { ToolService } from '../tool/tool.service';

@Injectable({
  providedIn: 'root'
})
export class LocalInterfaceService {
  constructor(
    private storageSrv: StorageService,
    private onlineInterfaceSrv: OnlineInterfaceService,
    private HttpJavaService: HttpJavaService,
    private globalInterfaceSrv: GlobalSettingsService,
    private toolService: ToolService,

  ) { }

  login = (username, password, token) => {
    this.globalInterfaceSrv.removeGlobalSettings()
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.login(username, password, token)
        .then(async res => {
          this.toolService.showConsoleLog(res);
          this.storageSrv.setUser(res.content[0].userId);
          this.storageSrv.setUserName(res.content[0].name);
          this.storageSrv.setOwner(res.content[0].ownerId);
          this.storageSrv.setType(res.content[0].type);
          this.storageSrv.setMobile(res.content[0].mobile);
          this.storageSrv.setIsStaff(res.content[0].isStaff);
          this.storageSrv.setToken(res.content[0].token);
          this.storageSrv.setFacilityId(res.content[0].facilityId);
          this.storageSrv.setFacilityCcy(res.content[0].ccy);
          this.storageSrv.setFacilityName(res.content[0].facilityName);
          this.storageSrv.setFacilityPhoneNumber(res.content[0].facilityNumber);
          this.storageSrv.setFacilityOfficialName(res.content[0].officialName);
          this.storageSrv.setFacilityTaxNumber(res.content[0].taxNumber);
          this.storageSrv.setCalendarTimeSlots(res.content[0].calendarTimeSlots);
          this.storageSrv.setSharedWallet(res.content[0].sharedWallet);
          this.storageSrv.setPendingPayment(res.content[0].showPendingPayment);
          this.storageSrv.setFacilityCountryCode(res.content[0].countryCode);
          this.storageSrv.setCalendarStartTime(res.content[0].startTime);
          this.storageSrv.setCalendarEndTime(res.content[0].endTime);
          await this.globalInterfaceSrv.loadGlobalSettings(res.content[0].facilityId)
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }




  changeOwnerFacility = (token, facilityId) => {
    this.globalInterfaceSrv.removeGlobalSettings()
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.changeOwnerFacility(token, facilityId)
        .then(async res => {
          this.storageSrv.setUser(res.content[0].userId);
          this.storageSrv.setUserName(res.content[0].name);
          this.storageSrv.setOwner(res.content[0].ownerId);
          this.storageSrv.setType(res.content[0].type);
          this.storageSrv.setMobile(res.content[0].mobile);
          this.storageSrv.setIsStaff(res.content[0].isStaff);
          //this.storageSrv.setToken(res.content[0].token);
          this.storageSrv.setFacilityId(res.content[0].facilityId);
          this.storageSrv.setFacilityCcy(res.content[0].ccy);
          this.storageSrv.setFacilityName(res.content[0].facilityName);
          this.storageSrv.setFacilityPhoneNumber(res.content[0].facilityNumber);
          this.storageSrv.setFacilityOfficialName(res.content[0].officialName);
          this.storageSrv.setFacilityTaxNumber(res.content[0].taxNumber);
          this.storageSrv.setCalendarTimeSlots(res.content[0].calendarTimeSlots);
          this.storageSrv.setSharedWallet(res.content[0].sharedWallet);
          this.storageSrv.setPendingPayment(res.content[0].showPendingPayment);
          this.storageSrv.setFacilityCountryCode(res.content[0].countryCode);
          this.storageSrv.setCalendarStartTime(res.content[0].startTime);
          this.storageSrv.setCalendarEndTime(res.content[0].endTime);
          await this.globalInterfaceSrv.loadGlobalSettings(res.content[0].facilityId)
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getFacilitiesList = (country) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getFacilitiesList(country)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getCountriesList = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getCountriesList()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  logout = () => {
    this.globalInterfaceSrv.removeGlobalSettings()
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.logout()
        .then(res => {
          this.storageSrv.signOut();
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  changePassword = (oldPassword, newPassword) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.changePassword(this.storageSrv.getOwner(), oldPassword, newPassword)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Padel Getters -----------------//

  getDashboardStatistics = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getDashboardStatistics(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getBookings = (facilityId, pageNo, noOfRecords) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getBookings(facilityId, pageNo, noOfRecords)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getAllBookings = (queryString) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .getAllBookings(queryString)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
    
  }


  
  getBookingsClasses = (facilityId, pageNo, noOfRecords) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getBookingsClasses(facilityId, pageNo, noOfRecords)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getBookingStatus = (mobile, countryCode) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getBookingStatus(mobile, countryCode)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getBookingsById = (bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getBookingsById(bookingId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getBookingsCalendar = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getBookingsCalendar(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }


  getSingleDayBookings = (facilityId, date) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .getSingleDayBookingsOnline(facilityId, date)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }


  getBookingDetails = (bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .getSingleBookingDetails(bookingId)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }


  getBookingsCalendarHistory = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getBookingsCalendarHistory(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getCourtsCalendar = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.globalInterfaceSrv.getCourtsCalendar(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getDisabledCalendar = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getDisabledCalendar(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getPaymentMethods = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.globalInterfaceSrv.getPaymentMethods(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getTimingSlots = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.globalInterfaceSrv.getTimingSlots(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getCourts = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.globalInterfaceSrv.getCourts(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getBookingCategory = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.globalInterfaceSrv.getBookingCategory(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getUserTypes = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getUserTypes()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getOffers = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getOffers(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getDisabled = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getDisabled(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getCoachDisabled = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getCoachDisabled(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getAddonsTable = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.globalInterfaceSrv.getAddonsTable(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getAddons = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.globalInterfaceSrv.getAddons(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getOwners = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getOwners(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getOwnersList = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getOwnersList()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getActiveUsers = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getActiveUsers()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getActiveFacilities = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getActiveFacilities()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getActiveFacilitiesBranches = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getActiveFacilitiesBranches()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getTapFacilityFiles = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getTapFacilityFiles(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getUsers = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getUsers()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getUsersFacility = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getUsersFacility()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getCoachesByFacility = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.globalInterfaceSrv.getCoachesByFacility()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getCoaches = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getCoaches()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getCoachPackages = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getCoachPackages()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getCoachPrice = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getCoachPrice(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getCustomer = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getCustomer(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getPayments = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getPayments(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getReports = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getReports(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getInvistigations = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getInvistigations()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getMatchResults = (matchId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getMatchResults(matchId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getMatchPlayers = (matchId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getMatchPlayers(matchId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getClassPlayers = (classId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getClassPlayers(classId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }


  getInvistigationActions = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getInvistigationActions()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getReportsAllChannels = (facilityId, paymentMonth) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getReportsAllChannels(facilityId, paymentMonth)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getPromotions = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getPromotion(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getPromotionConfig = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getPromotionConfig(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getPromotionsAdmin = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getPromotionAdmin(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getFacilities = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getFacilities()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getFacilitiesPaymentMethod = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getFacilitiesPaymentMethod()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }


  getCoachesPaymentMethods = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getCoachesPaymentMethod()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getCoachPaymentMethods = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getCoachPaymentMethods()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getFacilityPaymentMethod = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getFacilityPaymentMethods()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getFacilitySchedule = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getFacilitySchedule(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getFacilityTiming = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getFacilityTiming(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getFacilityEvent = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getFacilityEvent(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getFacilityImages = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getFacilityImages(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getTapFiles = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getTapFiles()
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getTapOnboarding = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getTapOnboarding(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getBookingReoccur = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getBookingReoccur(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }
  addBookingReoccurActual = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addBookingReoccurActual(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getMembership = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getMembership(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }
  getTapFilePurpose = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getTapFilePurpose(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }
  getMembershipAddonsByUser = (facilityId, mobile, countryCode) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getMembershipAddonsByUser(facilityId, mobile, countryCode)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }


  getMembershipList = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getMembershipList(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getOwnerFacilityList = (ownerId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getOwnerFacilityList(ownerId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getCustomerInfo = (mobile, countryCode) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getCustomerInfo(mobile, countryCode)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Padel CRUD -----------------//

  //--------------- Court -----------------//

  addCourt = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addCourt(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateCourt = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateCourt(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteCourt = (courtId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteCourt(courtId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Booking Category -----------------//

  addBookingCategory = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addBookingCategory(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateBookingCategory = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateBookingCategory(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteBookingCategory = (BookingCategoryId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteBookingCategory(BookingCategoryId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Facility -----------------//

  addFacility = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addFacility(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateFacility = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateFacility(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteFacility = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteFacility(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Facility Payment Methods -----------------//

  addFacilityPaymentMethods = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addFacilityPaymentMethods(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateFacilityPaymentMethods = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateFacilityPaymentMethods(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteFacilityPaymentMethods = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteFacilityPaymentMethods(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Coach Payment Methods -----------------//

  addCoachPaymentMethods = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addCoachPaymentMethods(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateCoachPaymentMethods = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateCoachPaymentMethods(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteCoachPaymentMethods = (coachId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteCoachPaymentMethods(coachId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Facility Schedule -----------------//

  addFacilitySchedule = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addFacilitySchedule(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateFacilitySchedule = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateFacilitySchedule(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteFacilitySchedule = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteFacilitySchedule(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Facility Timing -----------------//

  addFacilityTiming = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addFacilityTiming(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateFacilityTiming = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateFacilityTiming(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteFacilityTiming = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteFacilityTiming(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Booking Reoccur -----------------//

  addBookingReoccur = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addBookingReoccur(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateBookingReoccur = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateBookingReoccur(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteBookingReoccur = (bookingReoccurId, bookingFixedId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteBookingReoccur(bookingReoccurId, bookingFixedId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getBookingFixedClassTable = (bookingFixedId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getBookingFixedClassTable(bookingFixedId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Facility Images -----------------//

  addFacilityImages = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addFacilityImages(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateFacilityImages = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateFacilityImages(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteFacilityImages = (facilityImageId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteFacilityImages(facilityImageId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Facility Event -----------------//

  addFacilityEvent = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addFacilityEvent(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateFacilityEvent = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateFacilityEvent(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteFacilityEvent = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteFacilityEvent(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Investigation -----------------//

  updateMatchResultStatus = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateMatchResultStatus(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateInvistigation = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateInvistigation(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Addon -----------------//

  addAddon = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addAddon(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateAddon = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateAddon(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteAddon = (addonId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteAddon(addonId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Customer -----------------//

  addCustomer = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addCustomer(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateCustomer = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateCustomer(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteCustomer = (customerId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteCustomer(customerId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- User -----------------//

  addUser = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addUser(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateUser = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateUser(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteUser = (userId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteUser(userId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- User -----------------//

  addUserFacility = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addUserFacility(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateUserFacility = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateUserFacility(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteUserFacility = (userId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteUserFacility(userId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Coach -----------------//

  addCoach = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addCoach(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateCoach = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateCoach(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteCoach = (CoachId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteCoach(CoachId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Coach Package -----------------//

  addCoachPackage = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addCoachPackage(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateCoachPackage = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateCoachPackage(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteCoachPackage = (CoachPackageId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteCoachPackage(CoachPackageId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Owner -----------------//

  addOwner = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addOwner(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateOwner = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateOwner(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteOwner = (ownerId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteOwner(ownerId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Booking -----------------//

  deleteBooking = (bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteBooking(bookingId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  markBookingNoShow = (bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.markBookingNoShow(bookingId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Offer -----------------//

  addOffer = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addOffer(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateOffer = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateOffer(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteOffer = (offerId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteOffer(offerId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Coach Price Offer -----------------//

  addCoachPrice = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addCoachPrice(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateCoachPrice = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateCoachPrice(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteCoachPrice = (CoachPriceId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteCoachPrice(CoachPriceId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Disabled -----------------//

  addDisabled = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addDisabled(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateDisabled = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateDisabled(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteDisabled = (disabledId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteDisabled(disabledId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Coach Disabled -----------------//

  addCoachDisabled = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addCoachDisabled(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateCoachDisabled = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateCoachDisabled(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteCoachDisabled = (disabledId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteCoachDisabled(disabledId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Promotion -----------------//

  addPromotion = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addPromotion(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updatePromotion = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updatePromotion(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deletePromotion = (promotionId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deletePromotion(promotionId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Promotion Configuration -----------------//

  addPromotionConfig = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addPromotionConfig(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updatePromotionConfig = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updatePromotionConfig(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deletePromotionConfig = (promotionConfigId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deletePromotionConfig(promotionConfigId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Promotion Admin -----------------//

  addPromotionAdmin = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addPromotionAdmin(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updatePromotionAdmin = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updatePromotionAdmin(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deletePromotionAdmin = (promotionId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deletePromotionAdmin(promotionId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Membership -----------------//

  addMembership = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addMembership(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateMembership = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateMembership(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteMembership = (facilityMembershipUserId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteMembership(facilityMembershipUserId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Transaction -----------------//

  deleteTransaction = (paymentId, bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteTransaction(paymentId, bookingId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  confirmOfflinePayment = (paymentId, bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.confirmOfflinePayment(paymentId, bookingId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  addNewPayment = (facilityId, courtId, bookingId, ccy, paidAmount, paymentCode, selectedPlayer) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addNewPayment(facilityId, courtId, bookingId, ccy, paidAmount, paymentCode, selectedPlayer)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  refundPayment = (paymentId, sharedWallet) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.refundPayment(paymentId, sharedWallet)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }
  removeClassPlayer = (playerId, classId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.removeClassPlayer(playerId, classId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }
  removeMatchPlayer = (playerId, MatchId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.removeMatchPlayer(playerId, MatchId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  createMatch = (bookingId, matchType, category, requestToJoin, isPrivate, facilityId, noOfSets, userId, player1ACountryCode, player1AMobile,
    player2ACountryCode, player2AMobile, player1BCountryCode, player1BMobile, player2BCountryCode, player2BMobile, matchNotes) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.createMatch(bookingId, matchType, category, requestToJoin, isPrivate, facilityId, noOfSets, userId, player1ACountryCode, player1AMobile,
        player2ACountryCode, player2AMobile, player1BCountryCode, player1BMobile, player2BCountryCode, player2BMobile, matchNotes)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  cancelMatch = (userId, matchId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.cancelMatch(userId, matchId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  createClass = (bookingId,
    facilityId,
    coachId,
    noOfPlayers,
    classPrice,
    classCcy,
    userId,
    showInApp) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.createClass(bookingId,
        facilityId,
        coachId,
        noOfPlayers,
        classPrice,
        classCcy,
        userId,
        showInApp)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  cancelClass = (userId, classId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.cancelClass(userId, classId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }
  addClassPlayer = (userId, classId, mobile, countryCode, classPlayerPaymentMethod, showInApp, name) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addClassPlayer(userId, classId, mobile, countryCode, classPlayerPaymentMethod, showInApp, name)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }
  addMatchPlayer = (userId, matchId, mobile, countryCode, matchPlayerPaymentMethod, matchPlayerTeam, name) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addMatchPlayer(userId, matchId, mobile, countryCode, matchPlayerPaymentMethod, matchPlayerTeam, name)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }
  cancelRecurrantBooking = (staffId, bookingId, bookingDisabledDate) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.cancelRecurrantBooking(staffId, bookingId, bookingDisabledDate)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }
  sendVerifyOTP = (countryCode, mobile) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.sendVerifyOTP(countryCode, mobile)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  //--------------- Tap Files -----------------//

  addTapFiles = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addTapFiles(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateTapFiles = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateTapFiles(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteTapFiles = (facilityImageId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteTapFiles(facilityImageId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  addTapOnboarding = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.addTapOnboarding(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  updateTapOnboarding = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.updateTapOnboarding(fields)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  deleteTapOnboarding = (tapOnboardingId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.deleteTapOnboarding(tapOnboardingId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  resetUserPassword = (userId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.resetUserPassword(userId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }
  resetUserLevel = (userId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.resetUserLevel(userId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }
  actionCustomerWallet = (userId, staffId, actionType, amount, ccy, paymentMethod) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.actionCustomerWallet(userId, staffId, actionType, amount, ccy, paymentMethod)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }
  getWalletTransactionsForFacility = (userId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getWalletTransactionsForFacility(userId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getReportTypes = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.globalInterfaceSrv.getReportTypes(facilityId)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }

  getDashboardReportDetails = (facilityId, reportCode, startDate, endDate) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.onlineInterfaceSrv.getDashboardReportDetails(facilityId, reportCode, startDate, endDate)
        .then(res => {
          resolve(res);
        })
        .catch(async err => {
          reject(err);
        });
    });
  }


  // getTournaments = (facilityId,status) => {
  //   return new Promise<any>(async (resolve, reject) => {
  //     await this.onlineInterfaceSrv.getTournaments(facilityId,status)
  //     .then(res => {
  //       resolve(res);
  //     })
  //     .catch(async err => {
  //       reject(err);
  //     });
  //   });
  // }

  getTournaments = (queryString) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .getAllTournaments(queryString)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }
  
  getSignedURL = (fileExt, contentType) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .getSignedURLS3(fileExt, contentType)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }


  uploadImageFileToS3 = (uploadURL, file) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .uploadImageFileToS3(uploadURL, file)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }


  saveTournament = (tournamentData) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .saveNewTournament(tournamentData)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }


  getTournamentDetails = (tournamentID) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .getCompleteTournamentDetails(tournamentID)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }

  saveTournamentCategory = (categoryData, tournamentID) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .saveNewTournamentCategory(categoryData, tournamentID)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }

  updateTournamentCategory = (categoryData, tournamentID, categoryID) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .updateNewTournamentCategory(categoryData, tournamentID, categoryID)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }

  deleteTournamentCategory = (tournamentID, categoryID) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .deleteTournamentCategory(tournamentID, categoryID)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }

  getTournamentCategoryList = (queryString, tournamentID) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .getCategoryList(queryString, tournamentID)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }

  getTournamentPaymentList = (queryString, tournamentID) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .getPaymentList(queryString, tournamentID)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }


  deleteTournamentPayment = (tournamentID, categoryID) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .deleteTournamentPayment(tournamentID, categoryID)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }

  saveTournamentPayment = (categoryData, tournamentID) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .saveNewTournamentPayment(categoryData, tournamentID)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }
  updateTournament = (tournamentData, id) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .updateExistingTournament(tournamentData, id)
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }

  balanceTransferBetweenCustomers = (balanceTransferPayload ) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.HttpJavaService
        .balanceShareBetweenCustomers(balanceTransferPayload, )
        .then((res) => {
          resolve(res);
        })
        .catch(async (err) => {
          reject(err);
        });
    });
  }

}